import React, { useRef } from 'react';
import HiddenGridRow from './HiddenGridRow';
import { useRowVisibility } from '../../Torpedo/BaseTorpedo/hooks/useRowVisibility';
import VisibleGridRow from './VisibleGridRow';
import OffsetTracking from '../../Torpedo/BaseTorpedo/_partials/OffsetTracking';
import LazyContext from '../../LazyLoadingImage/LazyContext';
import { LAZYLOAD_ROW_START } from '../../types';
var GridRow = function (_a) {
    var start = _a.start, end = _a.end, elementWidth = _a.elementWidth, elementHeight = _a.elementHeight, elementSpacing = _a.elementSpacing, scrollOptims = _a.scrollOptims, contentStrip = _a.contentStrip, rowIdx = _a.rowIdx, withShadowSpace = _a.withShadowSpace, renderElement = _a.renderElement, getDuperbrowseItemId = _a.getDuperbrowseItemId, onOffsetReached = _a.onOffsetReached, rowAlign = _a.rowAlign;
    var ref = useRef(null);
    var isVisible = useRowVisibility(ref, { enabled: scrollOptims });
    var rowStyle = {};
    if (rowAlign) {
        var settingToCss = {
            left: 'flex-start',
            right: 'flex-end',
            center: 'center',
        };
        rowStyle = { display: 'flex', justifyContent: settingToCss[rowAlign] };
    }
    return (React.createElement(LazyContext.Provider, { value: rowIdx >= LAZYLOAD_ROW_START },
        React.createElement(OffsetTracking, { rowIdx: rowIdx, onOffsetReached: onOffsetReached },
            React.createElement("div", { ref: ref, style: rowStyle },
                contentStrip,
                isVisible ? (React.createElement(VisibleGridRow, { start: start, end: end, elementWidth: elementWidth, elementHeight: elementHeight, elementSpacing: elementSpacing, withShadowSpace: withShadowSpace, renderElement: renderElement })) : (React.createElement(HiddenGridRow, { start: start, end: end, getDuperbrowseItemId: getDuperbrowseItemId, marginTop: elementSpacing, height: elementHeight }))))));
};
GridRow.displayName = 'GridRow';
export default GridRow;
//# sourceMappingURL=GridRow.js.map